import palette from '../../common/theme/palette';
import { loadImage, prepareIcon } from './mapUtil';

import directionSvg from '../../resources/images/direction.svg';
import backgroundSvg from '../../resources/images/background.svg';
import greenCircleBackgroundSvg from '../../resources/images/green-circle-background.svg';
import redCircleBackgroundSvg from '../../resources/images/red-circle-background.svg';
import yellowCircleBackgroundSvg from '../../resources/images/yellow-circle-background.svg';
import whiteCircleBackgroundSvg from '../../resources/images/white-circle-background.svg';
import greyCircleBackgroundSvg from '../../resources/images/grey-circle-background.svg';
import animalSvg from '../../resources/images/icon/animal.svg';
import bicycleSvg from '../../resources/images/icon/bicycle.svg';
import boatSvg from '../../resources/images/icon/boat.svg';
// import busSvg from '../../resources/images/icon/bus.svg';
import carSvg from '../../resources/images/icon/car.svg';
import craneSvg from '../../resources/images/icon/crane.svg';
import defaultSvg from '../../resources/images/icon/default.svg';
import helicopterSvg from '../../resources/images/icon/helicopter.svg';
import motorcycleSvg from '../../resources/images/icon/motorcycle.svg';
import offroadSvg from '../../resources/images/icon/offroad.svg';
import personSvg from '../../resources/images/icon/person.svg';
import pickupSvg from '../../resources/images/icon/pickup.svg';
import planeSvg from '../../resources/images/icon/plane.svg';
import scooterSvg from '../../resources/images/icon/scooter.svg';
import shipSvg from '../../resources/images/icon/ship.svg';
import tractorSvg from '../../resources/images/icon/tractor.svg';
import trainSvg from '../../resources/images/icon/train.svg';
import tramSvg from '../../resources/images/icon/tram.svg';
import trolleybusSvg from '../../resources/images/icon/trolleybus.svg';
// import truckSvg from '../../resources/images/icon/truck.svg';
// import vanSvg from '../../resources/images/icon/van.svg';
import phoneSvg from '../../resources/images/icon/phone.svg';

import poiBackgroundSvg from '../../resources/images/poiBackground.svg';
import bridgeSvg from '../../resources/images/icon/markers/bridge.svg';
import busStationSvg from '../../resources/images/icon/markers/busStation.svg';
import busStopSvg from '../../resources/images/icon/markers/busStop.svg';
import controlRoomSvg from '../../resources/images/icon/markers/controlRoom.svg';
import dataCenterSvg from '../../resources/images/icon/markers/dataCenter.svg';
import maintenanceSvg from '../../resources/images/icon/markers/maintenance.svg';
import officeSvg from '../../resources/images/icon/markers/office.svg';
import pedestrianBridgeSvg from '../../resources/images/icon/markers/pedestrianBridge.svg';
import railTunnelSvg from '../../resources/images/icon/markers/railTunnel.svg';
import roadTunnelSvg from '../../resources/images/icon/markers/roadTunnel.svg';
import stadiumSvg from '../../resources/images/icon/markers/stadium.svg';
import warehouseSvg from '../../resources/images/icon/markers/warehouse.svg';
import busSvg from '../../resources/images/icon/vehicle-categories/bus.svg';
import pickupTruckSvg from '../../resources/images/icon/vehicle-categories/pickup-truck.svg';
import sedanSvg from '../../resources/images/icon/vehicle-categories/sedan.svg';
import suvSvg from '../../resources/images/icon/vehicle-categories/suv.svg';
import trailerSvg from '../../resources/images/icon/vehicle-categories/trailer.svg';
import truckSvg from '../../resources/images/icon/vehicle-categories/truck.svg';
import vanSvg from '../../resources/images/icon/vehicle-categories/van.svg';

export const mapIcons = {
  // animal: animalSvg,
  // bicycle: bicycleSvg,
  // boat: boatSvg,
  // car: carSvg,
  // crane: craneSvg,
  // default: defaultSvg,
  // helicopter: helicopterSvg,
  // motorcycle: motorcycleSvg,
  // offroad: offroadSvg,
  // person: personSvg,
  // plane: planeSvg,
  // scooter: scooterSvg,
  // ship: shipSvg,
  // tractor: tractorSvg,
  // train: trainSvg,
  // tram: tramSvg,
  // trolleybus: trolleybusSvg,
  // phone: phoneSvg,
  Bus: busSvg,
  'Pickup Truck': pickupTruckSvg,
  Sedan: sedanSvg,
  SUV: suvSvg,
  'Trailer Truck': trailerSvg,
  'Box Truck': truckSvg,
  Van: vanSvg,
};

const mapPOIIcons = {
  poiBackground: poiBackgroundSvg,
  bridge: bridgeSvg,
  busStation: busStationSvg,
  busStop: busStopSvg,
  controlRoom: controlRoomSvg,
  dataCenter: dataCenterSvg,
  maintenance: maintenanceSvg,
  office: officeSvg,
  pedestrianBridge: pedestrianBridgeSvg,
  railTunnel: railTunnelSvg,
  roadTunnel: roadTunnelSvg,
  stadium: stadiumSvg,
  warehouse: warehouseSvg,
};

export const mapIconKey = (category) => (mapIcons.hasOwnProperty(category) ? category : 'default');
export const mapPOIIconKey = (type) => (mapPOIIcons.hasOwnProperty(type) ? type : 'default');

export const mapImages = {};

export const mapPOIImages = {};

export default async () => {
  const background = await loadImage(backgroundSvg);
  const redCircleBackground = await loadImage(redCircleBackgroundSvg);
  const greenCircleBackground = await loadImage(greenCircleBackgroundSvg);
  const yellowCircleBackground = await loadImage(yellowCircleBackgroundSvg);
  const whiteCircleBackground = await loadImage(whiteCircleBackgroundSvg);
  const greyCircleBackground = await loadImage(greyCircleBackgroundSvg);
  const backgrounds = {
    default: background,
    red: redCircleBackground,
    green: greenCircleBackground,
    yellow: yellowCircleBackground,
    white: whiteCircleBackground,
    grey: greyCircleBackground,
  };
  mapImages.background = await prepareIcon(background);
  mapImages.direction = await prepareIcon(await loadImage(directionSvg));

  const poiBackground = await loadImage(poiBackgroundSvg);
  mapPOIImages.poiBackground = await prepareIcon(poiBackground);

  await Promise.all(Object.keys(mapPOIIcons).map(async (type) => {
    const results = [];
    Object.keys(palette.markerColors).forEach((color) => {
      results.push(loadImage(mapPOIIcons[type]).then((icon) => {
        mapPOIImages[`${type}-${color}`] = prepareIcon(poiBackground, icon, palette.markerColors[color]);
      }));
    });
  }));

  await Promise.all(Object.keys(mapIcons).map(async (category) => {
    const results = [];
    ['primary', 'positive', 'negative', 'neutral', '#00eb00', '#ff2828', '#ffc41f', '#ffffff', '#676767'].forEach((color) => {
      results.push(loadImage(mapIcons[category]).then((icon) => {
        // Can be improved by using one circle background for all colors and leveraging canvas properties
        let newBackground;
        switch (color) {
          case '#00eb00'
            : newBackground = greenCircleBackground;
            break;
          case '#ff2828'
            : newBackground = redCircleBackground;
            break;
          case '#ffc41f'
            : newBackground = yellowCircleBackground;
            break;
          case '#ffffff'
            : newBackground = whiteCircleBackground;
            break;
          case '#676767'
            : newBackground = greyCircleBackground;
            break;
          default:
            newBackground = backgrounds[color] || background;
            break;
        }
        mapImages[`${category}-${color}`] = prepareIcon(newBackground, icon, palette.colors[color], true);
      }));
    });
    await Promise.all(results);
  }));
};
